// for web, it returns the element directly
const findNodeHandle = (node) => {
    return node;
};
export { findNodeHandle };
